module.exports = __webpack_public_path__ + "static/media/30OIOS11.5ae3c39b.jpg";